<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('Price.FCLSailingScheduleManagement')"
    width="350px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="shipping-schedule-form-dialog details-view"
  >
    <div class="main-content">
      <div style="margin-left: 10px;">
        <el-button type="primary" @click="onSubmit">{{ $t('Pricing.Save') }}</el-button>
        <el-button @click="onCancel">{{ $t('Pricing.Cancel') }}</el-button>
      </div>
      <div style="width: fit-content; margin: 10px">
        <div style="display: flex">
          <div class="section form-column">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item ref="pol" check :label="$t('Pricing.POL')">
                <cargo-advance-select
                  no="pol"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  filterable
                  :show-custom-label-in-option="true"
                  :default-value="ss.pol"
                  @parentCallBack="p=>{ss.pol=p.value}"
                />
              </el-form-item>
              <el-form-item ref="pod" check :label="$t('Pricing.POD')">
                <cargo-advance-select
                  no="pod"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  filterable
                  :show-custom-label-in-option="true"
                  :default-value="ss.pod"
                  @parentCallBack="p=>{ss.pod=p.value}"
                />
              </el-form-item>
              <el-form-item ref="transferPort" :label="$t('Pricing.TransferPort')">
                <cargo-advance-select
                  no="transferPort"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  filterable
                  :show-custom-label-in-option="true"
                  :default-value="ss.transferPort"
                  @parentCallBack="p=>{ss.transferPort=p.value}"
                />
              </el-form-item>
              <el-form-item ref="dockland" check :label="$t('Pricing.Dockland')">
                <el-input
                  v-model="ss.dockland"
                  no="dockland"
                />
              </el-form-item>
              <el-form-item ref="carrier" check :label="$t('Pricing.Carrier')">
                <cargo-advance-select
                  no="carrier"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{seaCmp:true}"
                  :custom-label="(item)=> item.cmpIdx > 0 ? `[${item.shortName}]${item.chineseName}` : ''"
                  :show-custom-label-in-option="true"
                  :default-value="ss.carrier"
                  @parentCallBack="p=>{ss.carrier=p.cmpIdx}"
                />
              </el-form-item>
              <el-form-item ref="lane" check :label="$t('Pricing.Lane')">
                <el-input
                  v-model="ss.lane"
                  no="lane"
                  :maxlength="64"
                />
              </el-form-item>
              <el-form-item ref="closingDay" check :label="$t('Pricing.ClosingDay')">
                <el-input
                  no="closingDay"
                  :disabled="true"
                  :value="ss.closingDay"
                />
              </el-form-item>
              <div class="form-flex">
                <el-checkbox-group v-model="closingDay" no="closingDay" style="width: 100%">
                  <el-col
                    v-for="code in frequencys"
                    :key="code"
                    style="width: 14%;"
                  >
                    <el-checkbox :label="code" />
                  </el-col>
                </el-checkbox-group>
              </div>
              <el-form-item ref="departureDay" check :label="$t('Pricing.DepartureDay')">
                <el-input
                  no="departureDay"
                  :disabled="true"
                  :value="ss.departureDay"
                />
              </el-form-item>
              <div class="form-flex">
                <el-checkbox-group v-model="departure" no="departure" style="width: 100%">
                  <el-col
                    v-for="code in frequencys"
                    :key="code"
                    style="width: 14%;"
                  >
                    <el-checkbox :label="code" />
                  </el-col>
                </el-checkbox-group>
              </div>
              <el-form-item :label="$t('Pricing.DaysUnitSea')">
                <el-input-number
                  v-model="ss.days"
                  no="days"
                  :min="0"
                  :value="ss.days"
                  controls-position="right"
                  :max="999999999"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item ref="beginDate" check :label="$t('Pricing.BeginDate')">
                <div style="display: flex">
                  <el-date-picker
                    v-model="ss.beginDate"
                    no="beginDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="flex: 1;"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item ref="endDate" check :label="$t('Pricing.EndDate')">
                <div style="display: flex">
                  <el-date-picker
                    v-model="ss.endDate"
                    no="endDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="flex: 1;"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item ref="remarks" check :label="$t('Pricing.Remarks')">
                <el-input
                  v-model="ss.remarks"
                  no="remarks"
                  type="textarea"
                  :maxlength="255"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import { saveShippingSchedule } from '@/api/price/shippingSchedule'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'

export default {
  name: 'ShippingScheduleForm',
  components: {
    CargoAgGrid, cargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    isNew: {
      type: Boolean,
      default: () => false
    },
    ss: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      fullscreenLoading: null,
      selectTypeNames: TYPE_NAMES,
      frequencys: PriceUtils.FREQUENCYS,
      config: null
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.selectRow = null
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    closingDay: {
      get() {
        return StrUtils.isEmpty(this.ss.closingDay) ? [] : this.ss.closingDay.split(',')
      },
      set(val) {
        this.ss.closingDay = val.join(',')
      }
    },
    departure: {
      get() {
        return StrUtils.isEmpty(this.ss.departureDay) ? [] : this.ss.departureDay.split(',')
      },
      set(val) {
        this.ss.departureDay = val.join(',')
      }
    }
  },
  created() {
    this.closingDay = StrUtils.isEmpty(this.ss.closingDay) ? [] : this.ss.closingDay.split(',')
    this.departure = StrUtils.isEmpty(this.ss.departureDay) ? [] : this.ss.departureDay.split(',')
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
    },
    onSubmit() {
      this.fullscreenLoading = getLoading()
      if (this.verifyForm()) {
        this.fullscreenLoading.close()
        return
      }
      if (this.verifySame('pol', 'pod')) {
        this.fullscreenLoading.close()
        return
      }
      if (this.ss.transferPort) {
        if (this.verifySame('transferPort', 'pod') || this.verifySame('transferPort', 'pol')) {
          this.fullscreenLoading.close()
          return
        }
      }
      if (this.ss.closingDay.length !== this.ss.departureDay.length) {
        const message = this.$t('Pricing.NotSameLength')
        const closingDay = this.$t('Pricing.ClosingDay')
        const departureDay = this.$t('Pricing.DepartureDay')
        this.$message.warning(StrUtils.substitute(message, closingDay, departureDay))
        this.fullscreenLoading.close()
        return
      }
      if (this.ss.beginDate > this.ss.endDate) {
        this.$message.warning(this.$t('Pricing.CompareValidate'))
        this.fullscreenLoading.close()
        return
      }
      this.ss.branchId = this.$store.getters.currentOfficeId
      saveShippingSchedule(this.ss).then((res) => {
        this.fullscreenLoading.close()
        this.$message.success(this.$t('Pricing.SavedSucceed'))
        this.$emit('close')
        this.$emit('reload')
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    verifyForm() {
      for (const ref in this.$refs) {
        if (this.$refs[ref].$attrs.check === '' && this.verifyField(ref)) {
          const label = this.$refs[ref].label
          const valid = this.$refs[ref].$attrs.valid
          if (valid) {
            this.$message.warning(valid + label)
            return true
          }
          this.$message.warning(label + this.$t('Pricing.WrongInput'))
          return true
        }
      }
    },
    verifyField(field) {
      if (typeof this.ss[field] === 'number') {
        return this.ss[field] === 0
      }
      return StrUtils.isEmpty(this.ss[field])
    },
    verifySame(field1, field2) {
      if (this.ss[field1] === this.ss[field2]) {
        const label1 = this.$refs[field1].label
        const label2 = this.$refs[field2].label
        const message = this.$t('Pricing.MustDifferent')
        this.$message.warning(StrUtils.substitute(message, label1, label2))
        return true
      }
      return false
    },
    onCancel() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss">
.shipping-schedule-form-dialog{
  .form-flex{
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  textarea.el-textarea__inner{
    min-height: 80px !important;
  }
}
</style>
